import { axiosClient } from "../../api/base/pruebaAuth";
import { Login } from "../../models/LoginModel/login.model";

export const login = async (data: Login): Promise<any> => {
  try {
      let URI ='users/login';
      let res: any = await axiosClient.post(URI, data);
    return res.data;
  } catch (e: any) {
    console.error(e);
    return Promise.reject("Autenticacion fallida");
  }
};

const services = {
  login,
};

export default services;
